import React from 'react';
import { Typography } from '@mui/material';

import { ErrorMessage } from '../error-message.component';

export function ForbiddenError(): JSX.Element {
  return (
    <ErrorMessage>
      <Typography variant='h2'>Forbidden</Typography>
      <Typography>{"You don't have permission to access this resource."}</Typography>
    </ErrorMessage>
  );
}
